export default __webpack_public_path__ + "static/media/img_banner01.1cd849e6.png";